import { ClockAlert } from 'lucide-react';
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import {
	DIALOG_CANCEL_CLASS,
	DIALOG_CONFIRM_CLASS,
	DIALOG_CONTENT_CLASS,
	DIALOG_DESCRIPTION_CLASS,
	DIALOG_FOOTER_CLASS,
	DIALOG_HEADER_CLASS,
	DIALOG_TITLE_CLASS
} from '@/components/shared/dialog-styles';

interface TimezoneMismatchDialogProps {
	open: boolean;
	shopifyTimezone: string;
	selectedTimezone: string;
	onOpenChange: (open: boolean) => void;
	/** Saves the operator's current selection as-is. */
	onKeepSelected: () => void;
	/** Switches the picker to the Shopify timezone and saves that instead. */
	onUseShopify: () => void;
}

/** Confirms before saving an Operating Hours timezone that disagrees with the Shopify store's. */
export function TimezoneMismatchDialog({
	open,
	shopifyTimezone,
	selectedTimezone,
	onOpenChange,
	onKeepSelected,
	onUseShopify,
}: TimezoneMismatchDialogProps) {
	return (
		<AlertDialog open={open} onOpenChange={onOpenChange}>
			<AlertDialogContent className={DIALOG_CONTENT_CLASS}>
				<AlertDialogHeader className={DIALOG_HEADER_CLASS}>
					<ClockAlert className='size-7 text-amber-500' />
					<AlertDialogTitle className={DIALOG_TITLE_CLASS}>Timezone doesn&apos;t match Shopify</AlertDialogTitle>
					<AlertDialogDescription className={DIALOG_DESCRIPTION_CLASS}>
						Kim uses this timezone for operating hours and for dates it tells customers, like billing and delivery dates.
					</AlertDialogDescription>
				</AlertDialogHeader>

				<div className='mx-5 mb-4 flex flex-col gap-2 rounded-[12px] border border-gray-300 bg-white px-3 py-2.5 text-[13px]'>
					<div className='flex items-center justify-between'>
						<span className='text-gray-800'>Shopify store</span>
						<span className='font-medium text-ink'>{shopifyTimezone}</span>
					</div>
					<div className='flex items-center justify-between'>
						<span className='text-gray-800'>You selected</span>
						<span className='font-medium text-amber-600'>{selectedTimezone}</span>
					</div>
				</div>

				<AlertDialogFooter className={DIALOG_FOOTER_CLASS}>
					<AlertDialogAction onClick={onKeepSelected} className={DIALOG_CANCEL_CLASS}>
						Keep {selectedTimezone}
					</AlertDialogAction>
					<AlertDialogAction onClick={onUseShopify} className={DIALOG_CONFIRM_CLASS}>
						Use Shopify timezone
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
